<div class="responsive-card d-flex flex-column gap-4">
  <ng-container *ngIf="!isLoading">
    <span class="responsive-card-title" i18n>Payment Amounts</span>
    <div class="d-flex flex-column gap-3">
      <div class="d-flex justify-content-between">
        <div class="d-flex gap-2">
          <span *ngIf="isAnnualMinimumEstimated; else annualMinimumLabel" class="payment-label" i18n>
            Estimated Annual Minimum
          </span>
          <ng-template #annualMinimumLabel>
            <span class="payment-label" i18n>Annual Minimum</span>
          </ng-template>
          <img
            [ngbTooltip]="annualMinimumTooltip"
            [triggers]="'hover focus click'"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5"
            [src]="'assets/icons/grey/CircleQuestion.svg'" />
        </div>
        <div class="amount-label">{{ annualMinimum | currency }}</div>
      </div>
      <hr class="divider" />
      <div class="d-flex justify-content-between flex-wrap">
        <div class="d-flex gap-2">
          <span class="payment-label" i18n>Estimated Annual Total</span>
          <img
            [ngbTooltip]="annualTotalTooltip"
            [triggers]="'hover focus click'"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5"
            [src]="'assets/icons/grey/CircleQuestion.svg'" />
        </div>
        <div class="amount-label">{{ estimatedAnnualTotal | currency }}</div>
      </div>
      <ng-container *ngIf="nextYearEstimatedAnnualTotal !== null">
        <hr class="divider" />
        <div class="d-flex justify-content-between flex-wrap">
          <span class="payment-label" i18n>Estimated {{ nextYear }} Total</span>
          <div class="amount-label">{{ nextYearEstimatedAnnualTotal | currency }}</div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="showError" class="d-flex gap-1 align-self-end align-items-start">
      <div>
        <img
          src="assets/icons/red/ExclamationCircle.svg"
          alt=""
          height="18"
          width="18"
          [style.height.rem]="1.125"
          [style.width.rem]="1.125" />
      </div>
      <div class="error-text" i18n>
        Adjust your payments so that your Estimated Annual Total meets the Annual Minimum requirement
      </div>
    </div>
  </ng-container>
  <lib-loading-shimmer *ngIf="isLoading" [width]="'100%'" [height]="'12rem'" />
</div>

<ng-template #annualMinimumTooltip>
  <ng-container *ngIf="isAnnualMinimumEstimated; else defaultAnnualMinimumTooltip" i18n>
    The minimum total payment amount required for the year, based on estimates from the previous year for the variable
    benefit account balance(s) and the selected minimum age(s)
  </ng-container>
  <ng-template #defaultAnnualMinimumTooltip>
    {{ annualMinimumTooltip$ | async }}
  </ng-template>
</ng-template>
<ng-template #annualTotalTooltip>
  <ng-container i18n>
    This figure reflects all payments made to date in the current year, combined with upcoming recurring and lump sum
    payments planned for this VB account.
  </ng-container>
</ng-template>
